import { ResetPassword } from "../components/MobileApp/ResetPasswordPage";
import { _fetch } from "./apiHelper";

export const resetPassword = async (data: ResetPassword) => {
  
  return fetch(`${import.meta.env.VITE_MLI_APP_API}/account/reset-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data)
  });
};
